import { PLATFORM_OPTIONS, PlatformValue, STORE_OPTIONS } from './marketingMath';

interface SegmentProps<V extends string> {
  label: string;
  options: readonly { value: V; label: string }[];
  value: V;
  onChange: (v: V) => void;
  testId: string;
}

function Segment<V extends string>({ label, options, value, onChange, testId }: SegmentProps<V>) {
  return (
    <div className="dash-toggle" role="group" aria-label={label} data-testid={testId}>
      {options.map((o) => (
        <button key={o.value || 'all'} type="button" aria-pressed={value === o.value}
          className={`dash-toggle__btn${value === o.value ? ' dash-toggle__btn--active' : ''}`}
          onClick={() => onChange(o.value)} data-testid={`${testId}-${o.value || 'all'}`}>
          {o.label}
        </button>
      ))}
    </div>
  );
}

/** Spec 084 — All / iOS / Android / Web; sent as `platform=` to the insights endpoints. */
export default function PlatformFilter({ value, onChange }: { value: PlatformValue; onChange: (v: PlatformValue) => void }) {
  return <Segment label="Platform" options={PLATFORM_OPTIONS} value={value} onChange={onChange} testId="platform-filter" />;
}

type StoreValue = typeof STORE_OPTIONS[number]['value'];

/** Spec 078 store filter (both / App Store / Google Play); sent as `store=` to `/store-taps`. */
export function StoreFilterToggle({ value, onChange }: { value: StoreValue; onChange: (v: StoreValue) => void }) {
  return <Segment label="Store" options={STORE_OPTIONS} value={value} onChange={onChange} testId="store-filter" />;
}
